// $lib/stores/store.js
import { writable } from "svelte/store";

export const user = writable(null);
export const accessToken = writable('');
export const loading = writable(true);
export const menus = writable([]);
export const lastSelectedReaction = writable(null);